<div class="container p-4">
    <div>
        <h4 class="d-inline me-5">Edit User</h4>
        <div class="form-check d-inline ms-5">
            <input class="form-checkbox" type="checkbox" id="isActive" name="isActive" [(ngModel)]="user.isActive">
            <label class="form-check-label ps-2" for="isActive">Active</label>
        </div>
    </div>
    <div class="form">
        <div>
            <label class="form-label" for="userFirstName">User's First Name</label>
            <input class="form-control" type="text" id="userFirstName" name="userFirstName" [(ngModel)]="user.firstName" />
        </div>
        <div>
            <label class="form-label" for="userLastName">User's Last Name</label>
            <input class="form-control" type="text" id="userLastName" name="userLastName" [(ngModel)]="user.lastName" />
        </div>
        <div>
            <label class="form-label" for="userEmail">User's Email</label>
            <input class="form-control" type="text" id="userEmail" name="userEmail" [(ngModel)]="user.email" />
        </div>
        <div class="mt-2" for="userExternalId">
            <label class="form-label me-5 mt-0">External ID (National ID)</label>
            <div class="text-end d-inline ms-5 mb-0">
                <input id="verifyExternalId" name="verifyExternalId" class="form-checkbox" type="checkbox" [(ngModel)]="user.verifyExternalId" /><label class="form-label mt-0 mb-0 ps-2" for="verifyExternalId">Verify External ID</label>
            </div>
            <input class="form-control" type="text" id="userExternalId" name="userExternalId" [(ngModel)]="user.externalId" />
        </div>
        <div class="mt-2">
            <input class="form-checkbox" type="checkbox" id="dexioAdmin" name="dexioAdmin" [(ngModel)]="user.isDexioAdmin" />
            <label class="form-label mt-0 mb-0 ps-2" for="dexioAdmin">Is Dexio Admin?</label>
        </div>
    </div>
    <div class="mt-3 row">
        <div class="col">
            <button type="button" class="btn btn-secondary" (click)="close()">Cancel</button>
        </div>
        <div class="col text-end">
            <button type="button" class="btn btn-primary" (click)="save()">Save</button>
        </div>
    </div>  
</div>